var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ [_vm.s.container]: _vm.isAbsolute }},[(_vm.$store.getters.isThemeDark)?_c('img',{attrs:{"src":require("@/assets/images/icons/LogoDark.svg")}}):_c('img',{attrs:{"src":require("@/assets/images/icons/LogoLight.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }